import React, { useState, useEffect } from "react";
import { Container, Row, Button } from "react-bootstrap";
import Particle from "../Particle";
import { AiOutlineDownload } from "react-icons/ai";

function ResumeNew() {
  const [width, setWidth] = useState(1200);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <div>
      <Container fluid className="resume-section">
        <Particle />
        <Row
          style={{
            justifyContent: "center",
            position: "relative",
            marginBottom: "2em",
          }}
        >
          <Button
            variant="primary"
            href={
              "https://drive.google.com/file/d/1Esah2TWR4CNyLjV5SgTTKUrHvNThUyw2/view?usp=sharing"
            }
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download Resume
          </Button>
        </Row>
        <img
          src={
            "https://res.cloudinary.com/dgsjlfsoi/image/upload/v1693751619/Capture_ectbsy.jpg"
          }
          className="img-fluid"
          alt="brand"
        />
        <Row
          style={{
            justifyContent: "center",
            position: "relative",
            marginTop: "2em",
          }}
        ></Row>
      </Container>
    </div>
  );
}

export default ResumeNew;
